import { defineNuxtPlugin } from "nuxt/app";
import { useAuthUser } from "~/composables/useAuthUser";

export default defineNuxtPlugin(async () => {
  const { refreshUser } = useAuthUser();
  await refreshUser();
});
